import { FeeVersionInterface } from '@/interfaces/FeeStructures.interface';
import BaseApiClient from '../BaseApiClient';
import { ListDataParams, ListDataResponse } from '../types';

export class ApiFeeVersions extends BaseApiClient {
  /**
   * Get fee versions
   */
  async list(
    feeId: number,
    listData: ListDataParams
  ): Promise<ListDataResponse<FeeVersionInterface>> {
    return new Promise((resolve, reject) => {
      this.client
        .getList(`/fees/${feeId}/fee-versions`, listData, {
          headers: { Version: '2025-11-14' }
        })
        .then((res) => {
          if (res.data) {
            resolve({
              items: res.data.data,
              pagination: {
                page: res.data.meta?.current_page,
                perPage: res.data.meta?.per_page,
                total: res.data.meta?.total
              }
            });
          } else {
            reject('Invalid response');
          }
        })
        .catch((err) => reject(err));
    });
  }

  /**
   * Create fee versions
   */
  async create(
    feeId: number,
    feeVersion: Partial<FeeVersionInterface>
  ): Promise<FeeVersionInterface> {
    return new Promise((resolve, reject) => {
      this.client
        .post(`/fees/${feeId}/fee-versions`, feeVersion, {
          headers: { Version: '2025-11-14' }
        })
        .then((res) => {
          if (res.data) {
            resolve(res.data);
          } else {
            reject('Invalid response');
          }
        })
        .catch((err) => reject(err));
    });
  }

  /**
   * Update fee version
   */
  async update(feeVersionId: number, payload: Partial<FeeVersionInterface>): Promise<FeeVersionInterface> {
    return new Promise((resolve, reject) => {
      this.client
        .put(`/fee-versions/${feeVersionId}`, payload, {
          headers: { Version: '2025-11-14' }
        })
        .then((res) => {
          if (res.data) {
            resolve(res.data.data);
          } else {
            reject('Invalid response');
          }
        })
        .catch((err) => reject(err));
    });
  }

  /**
   * Duplicate fee version
   */
  async duplicate(feeVersionId: number, payload: Partial<FeeVersionInterface>): Promise<FeeVersionInterface> {
    return new Promise((resolve, reject) => {
      this.client
        .post(`/fee-versions/${feeVersionId}/fee-versions`, payload, {
          headers: { Version: '2025-11-14' }
        })
        .then((res) => {
          if (res.data) {
            resolve(res.data.data);
          } else {
            reject('Invalid response');
          }
        })
        .catch((err) => reject(err));
    });
  }


  /**
   * Get fee version
   */
  async get(feeVersionId: number): Promise<FeeVersionInterface> {
    return new Promise((resolve, reject) => {
      this.client
        .get(`/fee-versions/${feeVersionId}`, {
          headers: { Version: '2025-11-14' }
        })
        .then((res) => {
          if (res.data) {
            resolve(res.data.data);
          } else {
            reject('Invalid response');
          }
        })
        .catch((err) => reject(err));
    });
  }
}

export { feeVersionsQueryKeys } from './query-keys';
export type { FeeVersionsListQueryParams } from './query-keys';
export { useFeeVersionQuery, useFeeVersionsListQuery } from './use-fee-versions-queries';
export {
  useFeeVersionsCreateMutation,
  useFeeVersionsDuplicateMutation,
  useFeeVersionsUpdateMutation
} from './use-fee-versions-mutations';
export type {
  FeeVersionsCreateVariables,
  FeeVersionsDuplicateVariables,
  FeeVersionsUpdateVariables
} from './use-fee-versions-mutations';
